import type { ReactNode } from 'react'
import React from 'react'
import mapValues from 'lodash-es/mapValues'
import isObject from 'lodash-es/isObject'
import type { FeatureFlags, ProviderFeatureFlags } from './types'

type Props = {
  featureFlags: ProviderFeatureFlags
  children: ReactNode
}

export const FeatureFlagsContext = React.createContext<FeatureFlags | undefined>(undefined)

export const FeatureFlagsProvider = ({ featureFlags, children }: Props) => {
  const contextFeatureFlags = mapValues(featureFlags, (flag) => {
    if (isObject(flag)) return flag

    return { enabled: flag, highlight: false }
  })

  return (
    <FeatureFlagsContext.Provider value={contextFeatureFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
